(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/divided-code-input.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/divided-code-input.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  Fragment = _React.Fragment;
const Form = svs.ui.reactForm.Form;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const TextInput = svs.ui.reactFormInputs.TextInput;
const _svs$ticketsValidateM = svs.ticketsValidateManual.utils,
  constants = _svs$ticketsValidateM.constants,
  validateProductId = _svs$ticketsValidateM.validateProductId,
  validateTicketId = _svs$ticketsValidateM.validateTicketId;
const CODE_PART_LENGTHS = constants.CODE_PART_LENGTHS,
  ERRORS = constants.ERRORS;
const REQUIRED_ERROR = ERRORS.REQUIRED_ERROR,
  MESSAGE_MIN = ERRORS.MESSAGE_MIN,
  INVALID_PRODUCT_ID = ERRORS.INVALID_PRODUCT_ID;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const TWO_MINUTES = 2;
const validateEachCodePart = codeParts => codeParts.map((part, index) => {
  if (part.length < CODE_PART_LENGTHS[index]) {
    return MESSAGE_MIN;
  } else if (index === 0 && !validateProductId(part).isValid) {
    return INVALID_PRODUCT_ID;
  }
  return undefined;
}).reduce((error, partError, index) => _objectSpread(_objectSpread({}, error), {}, {
  ["code-part-".concat(index)]: partError
}), {});
setGlobal('svs.ticketsValidateManual.pages.home.components.DividedCodeInput', _ref => {
  let _ref$ticketId = _ref.ticketId,
    ticketId = _ref$ticketId === void 0 ? null : _ref$ticketId;
  const _svs$ticketsValidateM2 = svs.ticketsValidateManual.hooks.useLocalStorage('codeParts', 'tickets-validate-manual', {
      codeParts: CODE_PART_LENGTHS.map(() => '')
    }, TWO_MINUTES),
    _svs$ticketsValidateM3 = _slicedToArray(_svs$ticketsValidateM2, 3),
    state = _svs$ticketsValidateM3[0],
    setState = _svs$ticketsValidateM3[1],
    clearState = _svs$ticketsValidateM3[2];
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  const codeValidation = validateTicketId(state.codeParts.join('-'));
  useEffect(() => {
    const ticketIdParam = ticketId === null || ticketId === void 0 ? void 0 : ticketId.split('-'); 
    if ((ticketIdParam === null || ticketIdParam === void 0 ? void 0 : ticketIdParam.length) === 1) {
      const ticketIdString = ticketIdParam[0];
      for (let i = 0, startIndex = 0; i < CODE_PART_LENGTHS.length; i++) {
        ticketIdParam[i] = ticketIdString.slice(startIndex, startIndex + CODE_PART_LENGTHS[i]);
        startIndex += CODE_PART_LENGTHS[i];
      }
    }
    if (state.codeParts.join('').length === 0) {
      if ((ticketIdParam === null || ticketIdParam === void 0 ? void 0 : ticketIdParam.join('').length) > 0) {
        setState({
          codeParts: CODE_PART_LENGTHS.map((length, i) => {
            var _ticketIdParam$i$slic, _ticketIdParam$i;
            return (_ticketIdParam$i$slic = (_ticketIdParam$i = ticketIdParam[i]) === null || _ticketIdParam$i === void 0 ? void 0 : _ticketIdParam$i.slice(0, length)) !== null && _ticketIdParam$i$slic !== void 0 ? _ticketIdParam$i$slic : '';
          })
        });
        const errors = validateEachCodePart(ticketIdParam);
        if (Object.values(errors).some(error => error)) {
          setError(_objectSpread(_objectSpread({}, errors), {}, {
            code: validateTicketId(ticketIdParam.join('-')).errorMessage
          }));
          svs.ticketsValidateManual.logger.warn("Invalid ticketIdParam: ".concat(Object.values(errors).filter(error => error).join(', ')), ticketIdParam);
        }
      }
    } else {
      const errors = validateEachCodePart(state.codeParts);
      if (Object.values(errors).some(error => error)) {
        setError(_objectSpread(_objectSpread({}, errors), {}, {
          code: codeValidation.errorMessage
        }));
      }
    }
  }, []);
  const errorMessageFromFormData = formData => Object.entries(formData).reduce((error, _ref2) => {
    let _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return value.isValid ? error : _objectSpread(_objectSpread({}, error), {}, {
      [key]: value.errorMessage
    });
  }, {});

  const onBlur = e => {
    if (!e.relatedTarget && !codeValidation.isValid) {
      setError(_objectSpread(_objectSpread({}, validateEachCodePart(state.codeParts)), {}, {
        code: codeValidation.errorMessage
      }));
    }
  };
  const onChange = _ref4 => {
    let target = _ref4.target;
    error && setError(null); 

    const codePartIndex = Number(target.name.split('-').slice(-1)[0]);
    let nextIndex = codePartIndex + 1;
    const oldValue = state.codeParts[codePartIndex];
    const newValue = target.value.replace(/[^0-9]/g, '').slice(0, CODE_PART_LENGTHS[codePartIndex]);
    let rest = target.value.replace(/[^0-9]/g, '').slice(newValue.length);
    const newCodeParts = [...state.codeParts.slice(0, codePartIndex),
    target.value.length === target.selectionStart || !rest.length ? newValue : oldValue, ...state.codeParts.slice(codePartIndex + 1)];
    const shouldFocusNext = () => document.activeElement === target && newValue.length === CODE_PART_LENGTHS[codePartIndex];

    if (target.value.length === target.selectionStart) {
      while ((rest.length || shouldFocusNext()) && nextIndex < CODE_PART_LENGTHS.length) {
        const nextValue = rest.slice(0, CODE_PART_LENGTHS[nextIndex]);
        rest = rest.slice(nextValue.length);
        if (state.codeParts[nextIndex].length === 0 || nextValue.length >= newCodeParts[nextIndex].length) {
          newCodeParts[nextIndex] = nextValue;
        }
        const nextInput = target.form.elements["code-part-".concat(nextIndex)];
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
        nextIndex++;
      }
    } else {
      const cursorPosition = target.selectionStart - rest.length;
      requestAnimationFrame(() => {
        target.setSelectionRange(cursorPosition, cursorPosition);
      });
    }
    setState({
      codeParts: newCodeParts
    });
  };

  const onKeyDown = event => {
    const codePartIndex = Number(event.target.name.split('-').slice(-1)[0]);
    if (event.key === 'Backspace' && event.target.selectionStart === 0 && event.target.selectionEnd === 0) {
      const prevIndex = codePartIndex - 1;
      if (prevIndex >= 0) {
        event.preventDefault();
        const prevInput = event.target.form.elements["code-part-".concat(prevIndex)];
        prevInput.focus();
        prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
      }
    } else if (event.key === 'ArrowLeft' && event.target.selectionStart === 0) {
      const prevIndex = codePartIndex - 1;
      if (prevIndex >= 0) {
        event.preventDefault();
        const prevInput = event.target.form.elements["code-part-".concat(prevIndex)];
        prevInput.focus();
        prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
      }
    } else if (event.key === 'ArrowRight' && event.target.selectionStart === event.target.value.length) {
      const nextIndex = codePartIndex + 1;
      if (nextIndex < CODE_PART_LENGTHS.length) {
        event.preventDefault();
        const nextInput = event.target.form.elements["code-part-".concat(nextIndex)];
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
      }
    }
  };
  const onSubmit = async (e, formData) => {
    var _svs$core$urlMapping$;
    error && setError(null); 
    e.preventDefault();
    const codeValidation = validateTicketId(state.codeParts.join('-'));
    if (!codeValidation.isValid) {
      svs.ticketsValidateManual.logger.info('ticketId manual (divided) input fail');
      setError(_objectSpread(_objectSpread({}, errorMessageFromFormData(formData)), {}, {
        code: codeValidation.errorMessage
      }));
      return;
    }
    svs.ui.loader.show(); 
    svs.ticketsValidateManual.logger.info('ticketId manual (divided) input success');
    const _svs$ticketgames$tick = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(state.codeParts.join('-')),
      branding = _svs$ticketgames$tick.branding,
      shortName = _svs$ticketgames$tick.shortName;
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateManualValidation(shortName);
    const validatePath = (_svs$core$urlMapping$ = svs.core.urlMapping.get('ticketValidated')) === null || _svs$core$urlMapping$ === void 0 ? void 0 : _svs$core$urlMapping$.replace(':branding', branding).replace(':ticketId', state.codeParts.join('-')).replace('/:code', '');
    const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    const extraParams = {
      validateticketonline: true,
      branding
    };
    if (isLoggedIn) {
      var _svs, _svs$setupExtraData;
      await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
        extraData: extraParams
      }));
      svs.utils.url.navigate(validatePath);
    } else {
      svs.components.customer_login.login({
        returnNewCustomer: true,
        returnUrl: validatePath,
        extraParams
      });
    }
    clearState();
  };
  return React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-2"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement(Form, {
    className: "code-input-form margin-center",
    onSubmit: onSubmit,
    setError: error
  }, React.createElement("div", {
    className: "code-input-layout margin-bottom-1-half"
  },
  CODE_PART_LENGTHS.map((codePartLength, index) => {
    var _state$codeParts$inde;
    return React.createElement(Fragment, {
      key: index
    }, React.createElement(TextInput, {
      autoComplete: "off",
      className: "code-input u-inline-block input-length-".concat(codePartLength),
      "data-testid": "code-part-".concat(index),
      errorMessageRequired: REQUIRED_ERROR,
      helpMessage: "".concat(state.codeParts[index].length, "/").concat(codePartLength),
      inputMode: "numeric",
      label: state.codeParts[index].length ? "".concat(state.codeParts[index].length, "/").concat(codePartLength) : Array.from({
        length: codePartLength
      }, () => '•').join(' '),
      min: codePartLength,
      name: "code-part-".concat(index),
      onBlur: onBlur,
      onChange: onChange,
      onKeyDown: onKeyDown,
      validateFn: index === 0 ? validateProductId : null,
      value: (_state$codeParts$inde = state.codeParts[index]) !== null && _state$codeParts$inde !== void 0 ? _state$codeParts$inde : ''
    }), index + 1 < CODE_PART_LENGTHS.length ? React.createElement("span", {
      className: "f-800 f-normal code-hyphen"
    }, "-") : null, index === 2 ? React.createElement("br", null) : null);
  }), (error === null || error === void 0 ? void 0 : error.code) && React.createElement("div", {
    className: "u-flex u-flex-align-items-center margin-top-half"
  }, React.createElement(Icon, {
    className: "margin-left-1 margin-right-half",
    color: "fc-red",
    icon: "exclamation-sign",
    size: 200
  }), React.createElement("div", {
    className: "code-input-error-message f-200 padding-0 margin-bottom-0",
    "data-testid": "code-input-error"
  }, error === null || error === void 0 ? void 0 : error.code))), React.createElement(Button, {
    block: true,
    disabled: !codeValidation.isValid,
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"))));
});

 })(window);